@if (!itemsList().length) {
  <div class="d-flex justify-content-center align-items-center py-4 row {{mix()}}">
    {{ text() }}
  </div>
}
